export const COMPONENT_LOAD_ERROR = "Component load error";
